/* eslint-disable @angular-eslint/prefer-standalone */
import { Component, Input } from '@angular/core';

@Component({
  selector: 'dragonfly-table-skeleton',
  templateUrl: './table-skeleton.component.html',
  styleUrls: ['./table-skeleton.component.scss'],
  standalone: false,
})
export class TableSkeletonComponent {
  /** Number of placeholder body rows to render. */
  @Input() rows = 5;

  /** Whether to render the shimmer toolbar (items/sort/order buttons) above the rows. */
  @Input() showToolbar = true;

  get rowPlaceholders(): number[] {
    return Array.from({ length: this.rows }, (_, i) => i);
  }
}
